// 定义全局api接口地址，用于接收根据当前环境判读后使用的api-url地址
let apiUrl
var host = window.location.protocol + '//' + window.location.host
if (host.indexOf('localhost:') > -1) {
  host = 'https://test-gateway.yingxiong.com'
}

// 判断环境变量
if (process.env.NODE_ENV === 'development') { // 开发环境
  apiUrl = {
    bdc4_url: host + '/bdc4-server',
    gms_url: host + '/gs',
    gm_url: host + '/gm',
    gateway4: host + '/bdc4-gateway'
  }
} else if (process.env.VUE_APP_TITLE === 'stage') { // 预上线（测试环境）
  apiUrl = {
    bdc4_url: host + '/bdc4-server',
    gms_url: host + '/gs',
    gm_url: host + '/gm',
    gateway4: host + '/bdc4-gateway'
  }
} else if (process.env.VUE_APP_TITLE === 'production') { // 正式环境
  apiUrl = {
    bdc4_url: host + '/bdc4-server',
    gms_url: host + '/gs',
    gm_url: host + '/gm',
    gateway4: host + '/bdc4-gateway'
  }
} else if (process.env.VUE_APP_TITLE === 'k8s3') { // k8s3
  apiUrl = {
    bdc4_url: host + '/bdc4-server',
    gms_url: host + '/gs',
    gm_url: host + '/gm',
    gateway4: host + '/bdc4-gateway'
  }
}

export {
  apiUrl,
  host
}
